import { ApiService } from "Services/ApiService";
import {
    PaymentConfigEditRequestDTO,
    PaymentConfigRequestDTO,
    PaymentConfigResponseDTO,
} from "Types/Admin/Settings/PaymentType";
import { ResultsDTO } from "Types/ResultsDTO";

export const AdminPaymentApiSlice = ApiService.injectEndpoints({
    endpoints: (builder) => ({
        getPaymentConfig: builder.query<ResultsDTO<PaymentConfigResponseDTO>, void>({
            query: () => ({
                url: "/admin/payment-config",
                method: "GET",
                headers: {
                    origin: window.location.origin,
                },
            }),
            providesTags: ["Payment"],
        }),

        savePaymentConfig: builder.mutation<ResultsDTO, PaymentConfigRequestDTO>({
            query: (paymentConfig) => ({
                url: "/admin/payment-config/create",
                method: "POST",
                body: paymentConfig,
                headers: {
                    origin: window.location.origin,
                },
            }),
            invalidatesTags: ["Payment"],
        }),

        updatePaymentConfig: builder.mutation<ResultsDTO, PaymentConfigEditRequestDTO>({
            query: (paymentConfig) => ({
                url: "/admin/payment-config/update",
                method: "PUT",
                body: paymentConfig,
                headers: {
                    origin: window.location.origin,
                },
            }),
            invalidatesTags: ["Payment"],
        }),
    }),
});

export const {
    useGetPaymentConfigQuery,
    useSavePaymentConfigMutation,
    useUpdatePaymentConfigMutation,
} = AdminPaymentApiSlice;
